/**
 * Route table for the authenticated app shell.
 *
 * Role-gated routes wrap their page in <RouteGate allow={...}> so that
 * direct URL hits land on a friendly "no access" screen instead of a blank
 * page or an API 403.
 */

import { Switch, Route } from "wouter";
import { RouteGate } from "../components/RoleGate";
import { canSeeFinance, canManageUsers } from "../lib/constants";

import DashboardPage from "./pages/DashboardPage";
import ClientsPage from "./pages/ClientsPage";
import CasesPage from "./pages/CasesPage";
import PaymentsPage from "./pages/PaymentsPage";
import DeadlinesPage from "./pages/DeadlinesPage";
import ReportsPage from "./pages/ReportsPage";
import TeamsPage from "./pages/TeamsPage";
import SettingsPage from "./pages/SettingsPage";
import UsersPage from "./pages/UsersPage";
import ClientTrackerPage from "./pages/ClientTrackerPage";
import CurrentSituationPage from "./pages/CurrentSituationPage";
import NotFoundPage from "./pages/not-found";

export function AppRoutes() {
  return (
    <Switch>
      <Route path="/" component={DashboardPage} />
      <Route path="/clients" component={ClientsPage} />
      <Route path="/cases" component={CasesPage} />
      <Route path="/client-tracker" component={ClientTrackerPage} />
      <Route path="/current-situation" component={CurrentSituationPage} />
      <Route path="/payments">
        {() => (
          <RouteGate allow={canSeeFinance}>
            <PaymentsPage />
          </RouteGate>
        )}
      </Route>
      <Route path="/deadlines" component={DeadlinesPage} />
      <Route path="/reports">
        {() => (
          <RouteGate allow={canSeeFinance}>
            <ReportsPage />
          </RouteGate>
        )}
      </Route>
      <Route path="/teams">
        {() => (
          <RouteGate allow={canSeeFinance}>
            <TeamsPage />
          </RouteGate>
        )}
      </Route>
      <Route path="/users">
        {() => (
          <RouteGate allow={canManageUsers}>
            <UsersPage />
          </RouteGate>
        )}
      </Route>
      <Route path="/settings" component={SettingsPage} />
      <Route component={NotFoundPage} />
    </Switch>
  );
}
